import React, { PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

export const TrendingCardShadow = ({ children }: PropsWithChildren) => <Box style={styles.shadow}>{children}</Box>;

const styles = StyleSheet.create({
    shadow: {
        shadowColor: designSystem.colors.neutralBlack,
        shadowOffset: { width: -4, height: 0 },
        shadowOpacity: 0.8,
        shadowRadius: 16,
        elevation: 16,
        backgroundColor: ds.colorValue.background.neutral.subtler,
        borderRadius: 20,
        borderCurve: 'continuous',
    },
});
